import './parking-map.scss';
import 'assets/scripts/maps';
import 'magnific-popup';
import AOS from 'aos';

export default () => {
	AOS.init( {
		duration: 800,
		once: true,
	} );
	$( '.maps2' ).maps( {
		map: {
			disableDefaultUI: true,
			zoomControl: true,
		},
	} );
};
